import { render } from "./parametersComponent.vue?vue&type=template&id=5b6bf3c5&scoped=true"
import script from "./parametersComponent.vue?vue&type=script&lang=js"
export * from "./parametersComponent.vue?vue&type=script&lang=js"

import "./parametersComponent.vue?vue&type=style&index=0&id=5b6bf3c5&lang=scss&scoped=true"
import "./parametersComponent.vue?vue&type=style&index=1&id=5b6bf3c5&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6bf3c5"]])

export default __exports__